<template>
  <hi-page-column card grow>
    <transition name="fade">
      <div v-if="init" class="flex-block-center" style="height:100%;width:100%">
        Database maintenance may take a long time. Are you willing to continue?
        <div class="text-center pa-10">
          <span class="ui-text-clickable" @click="go">Start</span>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="!init" class="pa-8 ui-text" style="overflow: auto">
        Querying the database...
        <div v-for="item in log" :key="item" v-html="item"></div>
        <div v-for="item in duplicatedEmails" :key="item[0].email">
          Found duplicated email(x{{ item.length }}) "{{ item[0].email }}" -
          <span class="ui-text-clickable" @click="fixDuplicatedEmails(item)"
            >Action</span
          >
        </div>
      </div>
    </transition>
    <!--    ///////////////////////// dialogs /////////////////////////-->
    <DuplicatedEmails ref="duplicatedEmailsDialog"></DuplicatedEmails>
  </hi-page-column>
</template>

<script>
import { collections, db } from "@/db";
import { fixSource } from "@/api/leads";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import Hivue from "@/hive/Hivue";
import DuplicatedEmails from "@/components/conf/DLDuplicatedEmails";

export default {
  name: "DbMaintenanceViewer",
  data() {
    return {
      log: [],
      init: true,
      duplicatedEmails: []
    };
  },
  components: {
    DuplicatedEmails,
    HiPageColumn
  },
  methods: {
    logErr(msg) {
      this.log.push(`<span class="log-error">${msg} </span>`);
    },
    logMsg(msg, sep) {
      if (sep)
        this.log.push(
          `<div style="border-bottom:1px solid #bbbbbb">${msg} </div>`
        );
      else this.log.push(`<div>${msg} </div>`);
    },
    fixDuplicatedEmails(item) {
      console.log(item);
      const ids = [];
      for (let i = 0; i < item.length; i++) {
        ids.push(item[i].id);
      }
      this.$refs.duplicatedEmailsDialog.open(ids);
    },
    async go() {
      this.init = false;
      const emailDic = {};
      // const projects = await meta.projects();
      // const sources = await meta.sources();
      // console.log(projects);
      // console.log(sources);
      const counters = {
        all: 0,
        sources: {},
        projects: {}
      };
      collections.leads
        .get()
        .then(async snapshot => {
          if (!snapshot.empty) {
            const docs = snapshot.docs;
            this.log.push("Getting " + docs.length + " leads from database.");
            for (let i = 0; i < docs.length; i++) {
              // console.log(docs[i].data());
              const doc = docs[i];
              const data = docs[i].data();
              ///////////// invalid data ///////////////////////
              if (!data.projects || !data.projects.length) {
                this.logErr(
                  "Find invalid lead data without project: " +
                    data.name +
                    ". doc.id: " +
                    doc.id
                );
                continue;
              }
              if (!data.email || !data.email.length) {
                this.logErr(
                  "Find invalid lead data without email: " +
                    data.name +
                    ". doc.id: " +
                    doc.id
                );
                continue;
              }
              if (!data.name || !data.name.length) {
                this.logErr(
                  "Find invalid lead data without name: " + "doc.id: " + doc.id
                );
                continue;
              }
              /////// update counters /////////////////////////
              const src = data.source;
              const projects = data.projects;
              const allSrc = counters.sources;
              counters.all++;
              if (src) {
                if (!allSrc[src]) allSrc[src] = 1;
                else allSrc[src]++;
              }
              for (let p = 0; p < projects.length; p++) {
                let project = projects[p];
                if (!counters.projects[project]) {
                  counters.projects[project] = {
                    all: 0,
                    sources: {}
                  };
                }
                const projectCounter = counters.projects[project];
                projectCounter.all++;
                if (src) {
                  if (!projectCounter.sources[src])
                    projectCounter.sources[src] = 1;
                  else projectCounter.sources[src]++;
                }
              }
              //////  end update counters ////////////////////
              // console.log(doc.id);
              // const emails = data.emails;
              // // console.log(emails);
              // const email = emails ? emails[0] : "No-Email";
              // if (emails) {
              //   emails.forEach(e => {
              //     const arr = emailDic[e.value] || [];
              //     arr.push({ email: e.value, id: doc.id, name: data.name });
              //     emailDic[e.value] = arr;
              //   });
              // }
              const email = data.email;
              if (email && email.length) {
                const arr = emailDic[email] || [];
                arr.push({ email: email, id: doc.id, name: data.name });
                emailDic[email] = arr;
              }

              if (!data.source && data.regReferrer) {
                this.logMsg(
                  `Trying to update source for <span class="log-info">${data.name} (${email.value})</span> with referrer domain ${data.regReferrer}`
                );
                try {
                  const src = await fixSource(doc.id);
                  if (src) {
                    this.logMsg(
                      `Source updated to <span class="log-result">'${src}'</span> -
                    <span class="log-info">${data.name} (${email.value})</span> with referrer domain ${data.regReferrer}`
                    );
                  } else {
                    this.logMsg(
                      "No source found for " + data.regReferrerDomain
                    );
                  }
                  // console.log(src);
                } catch (e) {
                  // console.log(e);
                  this.logErr(
                    `Source update error: ${e.message} - ${data.name} (${data.emails[0].value})`
                  );
                }
              }
              // console.log(docs);
            }
            console.log(emailDic);
            console.log(counters);
            this.logMsg("Update counters...", true);
            const countersDoc = await db.doc("_counters/leads").get();
            this.logMsg(
              `<div style="display:flex">
                              <div style="width:200px">Old counters:<br/>
${Hivue.printObject(countersDoc.data().total)}</div>
                              <div style="flex-grow: 1">Updated counters:<br/>
${Hivue.printObject(counters)}</div>
                           </div>`,
              true
            );
            await db.doc("_counters/leads").update({ total: counters });
            this.logMsg("Finding duplicated emails..");
            for (let l in emailDic) {
              // console.log(emailDic[l]);
              const dic = emailDic[l];
              if (dic.length > 1) {
                this.duplicatedEmails.push(dic);
                // this.logMsg(
                //   `Found duplicated email(x${dic.length}) "${dic[0].email}" - <span class="ui-text-clickable">Action</span>`
                // );
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.error(`Database maintenance error: ${err.message}.`);
        });
    }
  }
};
</script>

<style scoped>
::v-deep .log-error {
  background-color: #eab9b0;
  color: darkred;
}
::v-deep .log-info {
  background-color: #edead6;
  font-weight: bold;
  padding-left: 5px;
  padding-right: 5px;
}
::v-deep .log-result {
  background-color: #dff4d7;
  color: darkolivegreen;
  font-weight: bold;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
